<template>
  <!-- Create a modal for a new user to register -->
  <div class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Register New Admin</p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Admin Permission Code:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded">
                  <input class="input"
                    type="text"
                    id="adminPermissionCode"
                    placeholder="Admin Permission Code"
                    v-model="adminPermissionCode"
                    required>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Company:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded">
                  <input class="input"
                    type="text"
                    id="company"
                    placeholder="Company"
                    v-model="company"
                    required>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Email:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input class="input"
                    type="email"
                    id="registerEmail"
                    placeholder="Email"
                    v-model="email"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Password:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded has-icons-left">
                  <input class="input"
                    type="password"
                    id="password"
                    placeholder="Password"
                    v-model="password"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded has-icons-left">
                  <input class="input"
                    type="password"
                    id="confirmPassword"
                    placeholder="Confirm Password"
                    v-model="confirmPassword"
                    @keyup="comparePasswords"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded">
                  <b class="help is-success" v-if="passwordsNotMatch">
                    Passwords match
                  </b>

                  <b class="help is-danger" v-if="!passwordsNotMatch">
                    Passwords do not match
                  </b>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
            <div class="field is-grouped">
              <div class="control">
                <button @click="register" class="button is-medium is-fullwidth">Submit</button>
              </div>
            </div>
        </footer>
      </div>
    </div>
</template>


<script>
  import firebase from 'firebase'
  import debounce from 'lodash/debounce';

  export default {
    data() {
      return {
        adminPermissionCode: '',
        permCode: '23wqHiou89#',
        usernameAvailable: true,
        company: '',
        email: '',
        password: '',
        confirmPassword: '',
        passwordsNotMatch: false
      }
    },
    methods: {

      toastErr(bool, message){
        if(!bool){
          this.$toasted.show(message, {
            theme: "outline",
            position: "bottom-center",
            duration : 3000,
            fitToScreen: true
          })
        }
      },
      //Check password to make sure it is consistent using debounce
      //debounce is a function provided by lodash to limit how
      //often a particularly expensive operation can be run.
      //In this case, we want to limit how often we access
      //the firebase database, waiting until the user has completely
      //finished typing before making the request.
      //Ensure user enters same password in both input fields
      comparePasswords:debounce( function() {
        return (this.passwordsNotMatch = (this.password == this.confirmPassword))
      },
      500),

      //Register new user with firebase authentication
      register() {
        if (this.adminPermissionCode !== this.permCode) {
          this.toastErr(false, 'Incorrect Admin Permission Code')
        } else {
          if (this.passwordsNotMatch==false) {
            this.toastErr(false, 'Passwords Do Not Match')
          } else {
            this.$store.dispatch('signAdminUp', {
              company: this.company,
              email: this.email,
              password: this.password
            })
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/adminRegister.vue